import { AxiosResponse } from "axios";
import { ApiBrave } from "../../Apis/Brave";
import {
  ILoteAgendamentoCadastroForm,
  ILoteAgendamentoDTO,
  ILoteDeliveryForm,
  ILoteLojaForm,
  ILoteItineranteForm,
  IImportarPlanilhaProps,
  IValidarPlanilhaProps,
  ITransferenciaValidacaoDTO,
  TipoServicoLote,
  ILoteAgendamentoResumoDTO,
} from "../../types/loteAgendamento";

const basePath = "/lote-agendamento";

export class LoteAgendamento {
  static async cadastrar(
    props: ILoteAgendamentoCadastroForm,
  ): Promise<AxiosResponse<ILoteAgendamentoDTO>> {
    return ApiBrave.post(basePath, props);
  }

  static async visualizar(
    uuid: string,
  ): Promise<AxiosResponse<ILoteAgendamentoResumoDTO>> {
    return ApiBrave.get(`${basePath}/${uuid}`);
  }

  static async vincularDelivery(
    props: ILoteDeliveryForm,
  ): Promise<AxiosResponse<ILoteAgendamentoDTO>> {
    const { uuid, ...data } = props;
    return ApiBrave.put(`${basePath}/${uuid}/vincular-delivery`, data);
  }

  static async vincularLoja({
    uuid,
    uuidLoja,
  }: ILoteLojaForm): Promise<AxiosResponse<ILoteAgendamentoDTO>> {
    return ApiBrave.put(`${basePath}/${uuid}/vincular-loja?uuidLoja=${uuidLoja}`);
  }

  static async vincularItinerante({
    uuid,
    uuidItinerante,
  }: ILoteItineranteForm): Promise<AxiosResponse<ILoteAgendamentoDTO>> {
    return ApiBrave.put(
      `${basePath}/${uuid}/vincular-itinerante?uuidItinerante=${uuidItinerante}`,
    );
  }

  static async downloadModelo(
    tipoServico: TipoServicoLote,
  ): Promise<AxiosResponse<Blob>> {
    return ApiBrave.get(`${basePath}/${tipoServico}/download-modelo`, {
      responseType: "blob",
    });
  }

  static async validarPlanilha({
    uuid,
    tipoServico,
    planilha,
  }: IValidarPlanilhaProps): Promise<
    AxiosResponse<ITransferenciaValidacaoDTO[]>
  > {
    const formData = new FormData();
    formData.append("planilha", planilha);

    return ApiBrave.post(
      `${basePath}/${uuid}/${tipoServico}/validar-planilha`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } },
    );
  }

  static async importarPlanilha({
    uuid,
    tipoServico,
    planilha,
    formaPagamento,
  }: IImportarPlanilhaProps): Promise<AxiosResponse<void>> {
    const formData = new FormData();
    formData.append("planilha", planilha);

    return ApiBrave.post(
      `${basePath}/${uuid}/${tipoServico}/importar-planilha?formaPagamento=${formaPagamento}`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } },
    );
  }
}
